import { render, staticRenderFns } from "./usersList.vue?vue&type=template&id=587c546e"
import script from "./usersList.vue?vue&type=script&lang=js"
export * from "./usersList.vue?vue&type=script&lang=js"
import style0 from "./usersList.vue?vue&type=style&index=0&id=587c546e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports